import { render, staticRenderFns } from "./classDetail.vue?vue&type=template&id=6ad3670c&scoped=true&"
import script from "./classDetail.vue?vue&type=script&lang=js&"
export * from "./classDetail.vue?vue&type=script&lang=js&"
import style0 from "./classDetail.vue?vue&type=style&index=0&id=6ad3670c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad3670c",
  null
  
)

export default component.exports